import { GatsbyCartPage } from '../features/cart'

export default GatsbyCartPage
